import moment from "jalali-moment";
import React, { useEffect, useRef, useState } from "react";
import { Spinner } from "react-bootstrap";
import { HiOutlineQrcode } from "react-icons/hi";
import {
  Link,
  useHref,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import ErrorIcon from "../../base/assets/icons/ErrorIcon";
import SuccessIcon from "../../base/assets/icons/SuccessIcon";
import Empty from "../../base/features/blocks/Empty";
import { apiService } from "../../base/service/service";
import moneyFormat from "../../base/utils/moneyFormat";
import { QRCodeSVG } from "qrcode.react";
import { useReactToPrint } from "react-to-print";

export default function UserTickets() {
  const [tickets, setTickets] = useState(null);
  const navigate = useNavigate();
  const searchParams = useSearchParams();
  const location = useLocation();
  const contentRef = useRef(null);
  const reactToPrintFn = useReactToPrint({
    contentRef,
    pageStyle: `
    @page { size: auto; margin: 15mm; }
    @media print {
      .page-break { break-after: page; page-break-after: always; }
    }
  `,
  });

  useEffect(() => {
    getUserTickets();
  }, []);

  useEffect(() => {
    if (localStorage.getItem("token") && !tickets) {
      getUserTickets();
    }
  }, [location]);

  function getUserTickets() {
    apiService({ url: `api/events/user/tickets` }).then((data) => {
      if (data && data.success === 1) {
        setTickets(data.tickets);
      }
      if (
        (data?.status === 401 || data?.status === 403) &&
        !window.location.href.includes("login=1")
      ) {
        navigate("?login=1");
      }
    });
  }
  return (
    <div className="container-fluid px-0">
      <div className="p-3 text-center header">
        <button
          onClick={
            window.Android
              ? () => window.Android.openPaymentLink(window.location.href)
              : reactToPrintFn
          }
          className="btn border-0 small bg-main text-white px-4"
        >
          پرینت
        </button>
      </div>
      {tickets ? (
        tickets.length === 0 ? (
          <Empty text={"هنوز خریدی انجام نداده اید"} />
        ) : (
          <div className="" dir="rtl" ref={contentRef}>
            {tickets.map((ticket, t) => (
              <div className="row mx-0 p-2">
                {t !== 0 && (
                  <div
                    className="page-break"
                    style={{ pageBreakAfter: "always", height: "1px" }}
                  />
                )}
                <div className="col-12 p-1 mt-2">
                  <div className="rounded10 border border-dark border2 p-1">
                    {/* <div className="row mx-0 fs-7 border-bottom border-dark pb-1 mb-1">
                      <div className="col px-0 text-center">
                        <div>
                          <SuccessIcon size={"20"} />
                          <span className="text-green mb-0 fw-bolder me-2">
                            پرداخت موفق
                          </span>
                        </div>
                      </div>
                    </div> */}
                    {/* {ticket.status === 1 && ( */}
                    <div className="row px-1 mx-0 my-2">
                      <div className="col-12 px-0 fs-6 text-center mb-1 align-self-center fw-bolder">
                        {ticket.event_date?.event?.title}
                      </div>
                      <div className="col-12 px-0 small text-center mb-3 align-self-center">
                        {ticket.event_date?.event?.venue?.short_address}
                      </div>
                    </div>
                    {/* )} */}
                    <div className="row mx-0">
                      <div className="col pe-0">
                        <div className="row px-1 mx-0 fs-7 mb-1">
                          <div className="col px-0">کد ورود به سالن:</div>
                          <div className="col-auto px-0 fs-5 mb-0 text-main fw-bolder">
                            {ticket.uuid}
                          </div>
                        </div>
                        <div className="row px-1 mx-0 fs-7 mb-1">
                          <div className="col px-0">خریدار:</div>
                          <div className="col-auto px-0 fw-bolder">
                            {ticket.name} - {ticket.phone}
                          </div>
                        </div>
                        {ticket.hide_price !== 1 && (
                          <div className="row px-1 mx-0 fs-7 mb-1">
                            <div className="col px-0">قیمت با ارزش افزوده:</div>
                            <div className="col-auto px-0 fw-bolder">
                              {moneyFormat(
                                ticket.final_price,
                                null,
                                "fw-bolder"
                              )}
                            </div>
                          </div>
                        )}
                        <div className="row px-1 mx-0 fs-7 mb-1">
                          <div className="col px-0">تاریخ برگزاری:</div>
                          <div className="col-auto px-0 fw-bolder fs-6">
                            {moment(
                              ticket.event_date.start_time,
                              "YYYY-MM-DD HH:mm:ss"
                            ).format(`HH:mm - jMM/jDD`)}
                          </div>
                        </div>
                        <div className="row px-1 mx-0 fs-7 mb-1">
                          <div className="col px-0">تاریخ خرید:</div>
                          <div className="col-auto px-0 fw-bolder">
                            {moment(
                              ticket.created_at,
                              "YYYY-MM-DD HH:mm:ss"
                            ).format(`HH:mm - jMM/jDD`)}
                          </div>
                        </div>
                        <div className="row px-1 mx-0 fs-7 mb-1">
                          <div className="col px-0">کد پیگیری تراکنش:</div>
                          <div className="col-auto px-0 fw-bolder">
                            {Number(ticket.uuid)}
                          </div>
                        </div>
                      </div>
                      <div className="col-4 ps-2 pe-1">
                        <QRCodeSVG
                          value={ticket.uuid}
                          height={160}
                          width={"100%"}
                        />
                      </div>
                    </div>
                    <div className="row mx-0">
                      {ticket.event_ticket_seats?.map((chair, c) => (
                        <div className="col-6 col-md-3 p-1">
                          <div className="row mx-0 bg-gray ps-0 pe-2 rounded10 py-1 fs-8">
                            <div className="col px-0 text-center">
                              <p className="mb-0">بخش</p>
                              <p className="mb-0 fw-bolder fs-6">
                                {chair.event_seat?.seat?.row?.section?.name}{" "}
                                {
                                  chair.event_seat?.seat?.row?.section?.floor
                                    ?.name
                                }
                              </p>
                            </div>
                            <div className="col px-0 text-center">
                              <p className="mb-0">ردیف</p>
                              <p className="mb-0 fs-6 fw-bolder">
                                {chair.event_seat?.seat?.row?.number}
                              </p>
                            </div>
                            <div className="col px-0 text-center">
                              <p className="mb-0">صندلی</p>
                              <p className="mb-0 fs-6 fw-bolder">
                                {chair.event_seat?.seat?.name ||
                                  chair.event_seat?.seat?.number}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <hr className="my-2" />
                    <div className="p-1">
                      <p className="small mb-1 fw-bolder">
                        خریدار گرامی لطفا به این نکات توجه فرمایید:
                      </p>
                      <p className="fs-7 mb-0">
                        •1) لطفا پرینت یا تصویر بلیت به همراه کارت شناسایی
                        خریدار را همراه داشته باشید. •2) رعايت حجاب و شئونات
                        اسلامي الزامي‌ست. •3) درصورتی که بلیت را از گیشه
                        خریده‌اید باید حتما دارای مهر گیشه باشد. •4) حتما
                        می‌بايست مشخصات يكي از همراهان، با مشخصات روي بليت يكسان
                        باشد. •5) خواهشمنديم نيم ساعت قبل از زمان اجرا در محل
                        حضور داشته باشيد. •6) جايگاه و شماره صندلي روي بليت مشخص
                        شده است، لطفا جايگاه خود را در نظر بگيريد. •7) اين برگ
                        به منزله بليت‌ شماست و فقط براي تاريخ و ساعت قيد شده
                        معتبر بوده و به‌هيچ‌وجه قابل عودت و يا تعويض نمي‌باشد.
                        •8) درصورت رعایت نکردن هریک از موارد عواقب برعهده خریدار
                        است
                      </p>
                    </div>
                    <hr className="my-2" />
                    <div className="row mx-0">
                      <div className="col px-1">
                        <div className="mb-2">خرید آنلاین بلیت - irana.app</div>
                        <div className="fs-7">
                          پشتیبانی: {ticket.event_date?.event?.phone}
                        </div>
                      </div>
                      <div className="col-auto px-0 pb-2 text-center">
                        <img
                          className="rounded10"
                          alt=""
                          height={70}
                          src={require("./irana_app.svg").default}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )
      ) : (
        <div className="text-center py-3 mt-5">
          <Spinner
            size="md"
            className="align-middle text-main"
            animation="border"
          />
        </div>
      )}
    </div>
  );
}
